(document.querySelectorAll('.cupholders input[type="radio"]').forEach(function (item) {
  item.addEventListener('change', function () {
    document.getElementById('selected-cupholder').innerHTML = this.value;
  });
}),
  document.querySelectorAll('.product-form__input input[type="radio"][name="Color"]').forEach(function (item) {
    item.addEventListener('change', function () {
      const selectedValue = this.value,
        formLabel = this.closest('.product-form__input').querySelector('.form__label #selected-color');
      formLabel && (formLabel.innerHTML = selectedValue);
    });
  }),
  document.querySelectorAll('.addon-product-wrapper input[type="radio"]').forEach(function (item) {
    item.addEventListener('change', function () {
      item.closest('.product-form__input').querySelector('.selected-value').innerHTML = this.value;
    });
  }),
  document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('.status-tabs.mobile .tab'),
      contents = document.querySelectorAll('.tab-content');
    function hideAllContents() {
      (contents.forEach(function (content) {
        content.style.display = 'none';
      }),
        tabs.forEach(function (tab) {
          tab.classList.remove('active');
        }));
    }
    function showAllContents() {
      (contents.forEach(function (content) {
        content.style.display = 'block';
      }),
        tabs.forEach(function (tab) {
          tab.classList.add('active');
        }));
    }
    function showContent(targetId) {
      var targetContent = document.getElementById(targetId);
      document.getElementById(targetId + '-tab-mobile')?.classList.add('active');
    }
    function handleTabClick(event) {
      (hideAllContents(),
        showContent(event.currentTarget.getAttribute('data-target')),
        tabs.forEach(function (tab) {
          tab.classList.remove('active');
        }),
        event.currentTarget.classList.add('active'));
    }
    function handleResize() {
      if (window.innerWidth < 990) {
        var activeTab = document.querySelector('.status-tabs.mobile .tab.active');
        (hideAllContents(), showContent(activeTab ? activeTab.getAttribute('data-target') : 'main-product'));
      } else showAllContents();
    }
    (handleResize(),
      tabs.forEach(function (tab) {
        tab.addEventListener('click', handleTabClick);
      }),
      window.addEventListener('resize', handleResize));
  }),
  document.addEventListener('DOMContentLoaded', function () {
    const elements = {
      announcementBar: document.getElementById('announcement-bar-with-slider'),
      mediaGallery: document.querySelectorAll('media-gallery.product__media-gallery'),
      sliderComponent: document.querySelectorAll('slider-component.main-slider'),
      productMedia: document.querySelectorAll('.product__media.media.media--transparent'),
      productMediaList: document.querySelectorAll('.product--thumbnail .product__media-list'),
    };
    if (
      elements.announcementBar &&
      Object.values(elements)
        .filter((el) => el instanceof NodeList)
        .every((nodeList) => nodeList.length > 0)
    ) {
      const adjustMainChildElementHeights = () => {
        const barHeight = elements.announcementBar.offsetHeight;
        const fullMaxHeight = `calc(100vh - ${barHeight}px)`;
        // Below 990px the thumbnail dots sit in normal flow directly beneath the image,
        // inside this same capped area. Reserve room for them on the IMAGE only, so a
        // short (landscape) viewport shrinks the photo slightly instead of pushing the
        // dots out of the gallery box and onto the "Dimensions & Specs" button below it.
        // The reserve only takes effect when the viewport is short enough to cap the
        // gallery, so taller (portrait / mobile) viewports are unaffected. Above 990px
        // the dots are absolutely positioned (they don't overflow), so no reserve.
        const dotsReserve = window.matchMedia('(max-width: 989px)').matches ? 48 : 0;
        const imageMaxHeight = `calc(100vh - ${barHeight + dotsReserve}px)`;
        elements.mediaGallery.forEach((el) => el.style.setProperty('max-height', fullMaxHeight, 'important'));
        elements.sliderComponent.forEach((el) => el.style.setProperty('max-height', fullMaxHeight, 'important'));
        elements.productMedia.forEach((el) => el.style.setProperty('max-height', imageMaxHeight, 'important'));
        elements.productMediaList.forEach((el) => el.style.setProperty('max-height', imageMaxHeight, 'important'));
        // The <img> itself is height:auto, so a container max-height doesn't constrain
        // it — it keeps its natural (aspect) height and spills ~30px past the capped
        // container, overlapping the top of the thumbnail dots on short viewports.
        // Cap the images to the same reserved height (object-fit:cover keeps aspect,
        // trimming a few px) so they never overflow onto the dots. Queried fresh each
        // run so lazily-injected config galleries are covered too.
        document
          .querySelectorAll('.product--thumbnail .product__media-list img')
          .forEach((el) => el.style.setProperty('max-height', imageMaxHeight, 'important'));
      };
      (adjustMainChildElementHeights(),
        window.addEventListener('resize', adjustMainChildElementHeights),
        new MutationObserver(adjustMainChildElementHeights).observe(elements.announcementBar, {
          attributes: !0,
          childList: !0,
          subtree: !0,
        }));
    } else
      console.error(
        'Some elements were not found or are empty:',
        Object.keys(elements).filter((key) => !elements[key] || elements[key].length === 0),
      );
  }),
  document.addEventListener('DOMContentLoaded', function () {
    let customChatElement = document.querySelector('inbox-online-store-chat'),
      shopifyChat = document.querySelector('#ShopifyChat'),
      chatAppDiv = document.querySelector('.chat-app'),
      closeChatButton = getCloseButton();
    function getCloseButton() {
      return customChatElement && customChatElement.shadowRoot
        ? customChatElement.shadowRoot.querySelector('[name="closeChat"]')
          ? customChatElement.shadowRoot.querySelector('[name="closeChat"]')
          : customChatElement.shadowRoot.querySelector('.chat-app--close-button')
        : document.querySelector('[name="closeChat"]');
    }
    function getToggleButton() {
      return customChatElement && customChatElement.shadowRoot
        ? customChatElement.shadowRoot.querySelector('button.chat-toggle')
        : customChatElement.querySelector('button.chat-toggle');
    }
    function handleCloseButton() {
      ((closeChatButton = getCloseButton()),
        closeChatButton &&
          closeChatButton.addEventListener('click', function () {
            shopifyChat.classList.remove('fixed-bottom');
            const toggleButton = getToggleButton();
            toggleButton &&
              toggleButton.addEventListener('click', function () {
                (shopifyChat.classList.add('fixed-bottom'), handleCloseButton());
              });
          }));
    }
    function handleChatPosition() {
      ((customChatElement = document.querySelector('inbox-online-store-chat')),
        (shopifyChat = document.querySelector('#ShopifyChat')));
      const toggleButton = getToggleButton();
      (shopifyChat &&
        (chatAppDiv && !toggleButton && (shopifyChat.classList.add('fixed-bottom'), handleCloseButton()),
        toggleButton &&
          toggleButton.addEventListener('click', function () {
            (shopifyChat.classList.add('fixed-bottom'), handleCloseButton());
          })),
        customChatElement &&
          customChatElement.shadowRoot &&
          observer.observe(customChatElement.shadowRoot, {
            childList: !0,
            subtree: !0,
          }));
    }
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          node.id === 'ShopifyChat'
            ? ((shopifyChat = node), handleChatPosition())
            : node.classList &&
              node.classList.contains('chat-app') &&
              ((chatAppDiv = node), handleCloseButton(), handleChatPosition());
        });
      });
    });
    (observer.observe(document.body, { childList: !0, subtree: !0 }),
      (shopifyChat || chatAppDiv) && handleChatPosition());
  }));

document.addEventListener('DOMContentLoaded', function () {
  function setupGalleryArrows(gallery) {
    if (gallery._arrowsReady) return;
    gallery._arrowsReady = true;

    var thumbnailSlider = gallery.querySelector('.thumbnail-slider');
    if (!thumbnailSlider) return;

    var tsPrev = thumbnailSlider.querySelector('.slider-button--prev');
    var tsNext = thumbnailSlider.querySelector('.slider-button--next');

    if (tsPrev) {
      tsPrev.removeAttribute('disabled');
      tsPrev.addEventListener(
        'click',
        function (e) {
          gallery.previousSlide();
        },
        true,
      );
    }

    if (tsNext) {
      tsNext.addEventListener(
        'click',
        function (e) {
          gallery.nextSlide();
        },
        true,
      );
    }
  }

  // Initial setup
  document.querySelectorAll('media-gallery.product__media-gallery').forEach(setupGalleryArrows);

  // Re-run setup when AJAX navigation adds new gallery elements
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!node.querySelectorAll) return;
        if (node.matches && node.matches('media-gallery.product__media-gallery')) setupGalleryArrows(node);
        node.querySelectorAll('media-gallery.product__media-gallery').forEach(setupGalleryArrows);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Keep nav buttons enabled globally
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      if (m.target.closest && m.target.closest('.thumbnail-slider')) {
        m.target.removeAttribute('disabled');
      }
    });
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
});
document.addEventListener('DOMContentLoaded', function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    requestAnimationFrame(function () {
      var isPreorder = Boolean(variant.is_preorder);
      var preorderLabel =
        (window.sectionSettings && window.sectionSettings.preorderButtonLabel) || 'Pre-Order';

      // Relabelling the CTA to "Pre-Order" is gated by
      // window.sectionSettings.preorderButtonLabelEnabled (see sections/configurator.liquid).
      // While it is false the data-is-preorder attribute is still kept in sync — only the
      // button copy is skipped, so the buttons keep whatever Next Step / Add to Cart label
      // configurator-product-form.js gave them.
      var labelPreorderButtons = Boolean(window.sectionSettings && window.sectionSettings.preorderButtonLabelEnabled);

      document.querySelectorAll('[data-is-preorder]').forEach(function (button) {
        button.dataset.isPreorder = String(isPreorder);
        if (!labelPreorderButtons) return;
        if (button.hasAttribute('disabled')) return;
        var span = button.querySelector('span');
        if (!span) return;
        if (isPreorder) {
          span.textContent = preorderLabel;
        }
      });
    });
  });
});
//# sourceMappingURL=/s/files/1/0636/0265/5480/t/58/assets/configurator-product.js.map?v=1732991879